import React from "react"
import { Helmet } from "react-helmet"
// import Apps from './Apps.js'
import classes from './Menu.module.scss'
import Phone from "../../components/Shared/Phone"

const familyMeals = () => {
  return (
    <div className={classes.familyMeals}>
      <Helmet>
        <title>Family Meals To Go at Mile Marker 158 Dockside</title>
        <meta name="description" content="Order family meals to go from Mile Marker 158 in Orange Beach. Fresh, chef-prepared dinners that serve four, complete with salad and bread." />
      </Helmet>
      
      <div className={classes.hdRow}>
        <div className={[classes.hdWrap, classes.inside8].join(' ')}>
          <h1><span className={classes.simple}>Family Dinner Made Easy with Our</span><br/> <span className={classes.port}>Family Meals To Go</span></h1>
        </div>
      </div>

      <div className={classes.menuSection}>
        <div className={[classes.sectionWrap, classes.inside9].join(' ')}>
          <div className={classes.menuBox}>
            <div className={classes.intro}>
              <p className={classes.dets}>Each Meal Serves 4, and Includes a House or Caesar Salad, Bread &amp; Strawberry Butter.</p>
              <p className={classes.call}>Call to Order: <span><Phone where="textLink" /></span></p>
            </div>
            <div className={[classes.innerWrap, classes.insideXl].join(' ')}>
              <div className={classes.menuItem}>
                <h4>Chicken or Shrimp Alfredo <span>... $42</span></h4>
                <p>Sauteed Gulf Shrimp or Grilled Chicken, Roasted Tomatoes, Spinach, Cavatappi Pasta, Alfredo Sauce</p>
              </div>

              <div className={classes.menuItem}>
                <h4>Seafood Pasta <span>... $54</span></h4>
                <p>Sauteed Gulf Shrimp, Crab, Roasted Tomatoes, Spinach, Cavatappi Pasta, Gouda Cream Sauce</p>
              </div>

              <div className={classes.menuItem}>
                <h4>Teriyaki Glazed Salmon <span>... $56</span></h4>
                <p>Pan Seared Salmon, Teriyaki Glaze, Spinach & Caramelized Onion Risotto, Honey Roasted Carrots</p>
              </div>

              <div className={classes.menuItem}>
                <h4>Fish of the Day <span>... $50</span></h4>
                <p>Pan Seared, Mushroom Risotto, Honey Roasted Carrots, Lemon Beurre Blanc</p>
              </div>
            </div>
            <div className={classes.togoDisc}><p>** To Go Orders Subject to Change Depending on Wait Times and Volume of Restaurant. <span>**</span></p></div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default familyMeals